import React from 'react';
import './FinalCTA.css';

const FinalCTA: React.FC = () => {
    return (
        <section className="final-cta" id="get-started">
            <div className="cta-container">
                <h2>Ready to Transform Your Email Experience?</h2>
                <p className="subtitle">Join thousands of professionals who've already simplified their inbox with MailMeld</p>

                <div className="cta-features">
                    <div className="cta-feature">
                        <span className="feature-check">✓</span>
                        Free Installation
                    </div>
                    <div className="cta-feature">
                        <span className="feature-check">✓</span>
                        2-Minute Setup
                    </div>
                    <div className="cta-feature">
                        <span className="feature-check">✓</span>
                        Works with Gmail
                    </div>
                </div>

                <a href="YOUR_GOOGLE_WORKSPACE_MARKETPLACE_LINK_HERE" className="cta-button">
                    <span>Install MailMeld Now</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginLeft: '8px' }}>
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                        <polyline points="12 5 19 12 12 19"></polyline>
                    </svg>
                </a>

                <div className="trust-badges">
                    <div className="badge">
                        <span className="badge-icon">🔒</span>
                        Secure & Private
                    </div>
                    <div className="badge">
                        <span className="badge-icon">⭐</span>
                        4.8/5 Rating
                    </div>
                    <div className="badge">
                        <span className="badge-icon">👥</span>
                        10K+ Users
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FinalCTA;